const MOBILE_CLASS = 'main-nav-mobile'
const MOBILE_ACTIVE_CLASS = 'main-nav-mobile--open'

const DESKTOP_SUBMENU_CLASS = 'main-nav-desktop__submenu'

const MOBILE_SUBMENU_CLASS = 'main-nav-mobile__submenu'

export { MOBILE_ACTIVE_CLASS, MOBILE_CLASS, MOBILE_SUBMENU_CLASS, DESKTOP_SUBMENU_CLASS }
